<mat-form-field 
    [appearance]="(showCollapsedModeSubject | async) ? 'outline' : 'fill'"
    [ngClass]="{'full-width':showCollapsedModeSubject | async}"
    class="background-white"
    
>
    
    <mat-label>{{'ss-general.search' | translate}}</mat-label>
    <input #searchInput matInput [value]="searchSubject | async"/>

    <button *ngIf="searchSubject | async;else searchIcon" matIconSuffix mat-icon-button (click)="searchSubject.next('')">
        <mat-icon>close</mat-icon>
    </button>

    <ng-template #searchIcon>
        <mat-icon color="primary" matIconSuffix>search</mat-icon>
    </ng-template>
    
</mat-form-field>